export function getLabel(boards) {
  if (boards.length === 0) {
    return 'Board'
  } else {
    return boards.map(board => board.name).join(', ')
  }
}
